import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";
import "./gallery.scss";

function CreateGallery() {
  const navigate = useNavigate();
  const [tourCategory, setTourCategory] = useState("");
  const [title, setTitle] = useState("");
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const breadcrumbItems = [
    { title: "Gallery", link: "/gallery" },
    { title: "Create Gallery Item", link: "#" },
  ];

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoFile(file);
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!tourCategory) {
      alert("Please select a tour category.");
      return;
    }
    if (!photoFile) {
      alert("Please select a photo.");
      return;
    }

    try {
      setSubmitting(true);

      const formDataToSend = new FormData();
      formDataToSend.append("tour_category", tourCategory);
      formDataToSend.append("title", title);
      formDataToSend.append("photo", photoFile);

      const response = await fetch(`${config.API_BASE_URL}/gallery`, {
        method: "POST",
        headers: {
          "ngrok-skip-browser-warning": "true",
        },
        body: formDataToSend,
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        navigate("/gallery");
      } else {
        alert(data.message || data.error || "Failed to create gallery item");
      }
    } catch (error) {
      console.error("Error creating gallery item:", error);
      alert("Error creating gallery item");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate("/gallery");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Create Gallery Item"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label className="form-label">
                            Tour Category <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="select"
                            name="tourCategory"
                            className="form-control"
                            value={tourCategory}
                            onChange={(e) => setTourCategory(e.target.value)}
                            required
                          >
                            <option value="">Select Tour Category</option>
                            <option value="Leisure">Leisure</option>
                            <option value="Spiritual">Spiritual</option>
                            <option value="Experiential">Experiential</option>
                            <option value="MICE">MICE</option>
                            <option value="Educational">Educational</option>
                          </Input>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="mb-3">
                          <Label className="form-label">
                            Title <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="title"
                            className="form-control"
                            placeholder="e.g. Mountain Trekking"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label className="form-label">
                            Photo <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="file"
                            className="form-control"
                            onChange={handlePhotoChange}
                            accept="image/*"
                            required
                          />
                          {photoPreview && (
                            <div className="mt-2">
                              <img
                                src={photoPreview}
                                alt="Preview"
                                className="img-thumbnail"
                                style={{ maxHeight: "150px" }}
                              />
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col className="d-flex justify-content-end">
                        <Button
                          type="submit"
                          color="primary"
                          className="me-2"
                          disabled={submitting}
                        >
                          {submitting ? "Creating..." : "Create Gallery Item"}
                        </Button>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={handleCancel}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default CreateGallery;
